import { render, staticRenderFns } from "./TableSubColor.vue?vue&type=template&id=b6560f9e&scoped=true"
import script from "./TableSubColor.vue?vue&type=script&lang=js"
export * from "./TableSubColor.vue?vue&type=script&lang=js"
import style0 from "./TableSubColor.vue?vue&type=style&index=0&id=b6560f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6560f9e",
  null
  
)

export default component.exports